export const MINUTES_IN_HOUR = 60;
export const MINUTES_IN_DAY = 1440;
export const MINUTES_IN_YEAR = 525600;
